import React from 'react'
import Typography from 'material-ui/Typography'
import { withStyles } from 'material-ui/styles'
import styles from './styles'

import GetResultView from './getResult'

const ResultViewer = props => {
  const {
    job,
    translate,
    results,
    subtest,
    pager,
    getSubtestResults,
    subtestResultsDisplay,
    subtestResultsRemote,
    subtestResultsWiremap,
    chartLineStyle,
    chartMeasurement,
    chartMeasurementUnit,
    wiremapStandard,
    showMargin,
    setPreferences,
    preferences,
    onChangeResultsViewer
  } = props

  if (
    (results && results.data.subtests.length) ||
    (results.data.testedcabletype === 'FiberCable' ||
      results.data.testedcabletype === 'Fiber' ||
      results.data.testedcabletype === 'MobileTest') ||
    (results.data.lfttest && results.data.lfttest.length) ||
    (results.data.othersubtests && results.data.othersubtests.length)
  ) {
    let test = subtest
    if (
      results.data.testedcabletype === 'FiberCable' ||
      results.data.testedcabletype === 'Fiber'
    ) {
      test = results.data.testedcabletype
    }

    if (results.data.testedcabletype === 'MobileTest'){
      test = "MobileTestSummary";
    }

    let View = GetResultView(test)
    return View
      ? <View
        job={job}
        results={results}
        subtest={test}
        translate={translate}
        pager={pager}
        getSubtestResults={getSubtestResults}
        subtestResultsRemote={subtestResultsRemote}
        subtestResultsDisplay={subtestResultsDisplay}
        subtestResultsWiremap={subtestResultsWiremap}
        chartLineStyle={chartLineStyle}
        chartMeasurement={chartMeasurement}
        chartMeasurementUnit={chartMeasurementUnit}
        wiremapStandard={wiremapStandard}
        showMargin={showMargin}
        setPreferences={setPreferences}
        preferences={preferences}
        onChangeResultsViewer={onChangeResultsViewer}
        />
      : null
  } else {
    return (
      <Typography type='button'>
        No data
      </Typography>
    )
  }
}

export default withStyles(styles)(ResultViewer)



// WEBPACK FOOTER //
// ./src/components/common/results/resultsViewer.js